import { Dialog, type Props as DialogProps } from '~/components/Dialog/Dialog';
import { Button } from '~/components/Button/Button';
import { Portal } from '@headlessui/react';

type Props = Omit<DialogProps, 'children'> & {
  onConfirm: () => void;
  isLoading: boolean;
};

export function ConfirmDialog({ isOpen, isLoading, onClose, onConfirm }: Props) {
  return (
    <Portal>
      <Dialog isOpen={isOpen} onClose={onClose}>
        <Dialog.Title>Är du helt säker?</Dialog.Title>

        <Dialog.Text>
          De ändringar du håller på att göra kan inte ångras. Om du fortsätter går det inte att återställa dem.
        </Dialog.Text>

        <Button.Group align="right">
          <Button variant="secondary" onClick={onClose}>
            Avbryt
          </Button>
          <Button variant="destructive" onClick={onConfirm} isLoading={isLoading}>
            Ja, fortsätt
          </Button>
        </Button.Group>
      </Dialog>
    </Portal>
  );
}
